import { WebTracerProvider,
  BatchSpanProcessor
 } from '@opentelemetry/sdk-trace-web';
import { HttpSpanNameProcessor } from './HttpSpanNameProcessor';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { UserInteractionInstrumentation } from '@opentelemetry/instrumentation-user-interaction';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { resourceFromAttributes } from '@opentelemetry/resources';

console.log("Initializing OpenTelemetry Tracing");

const exporter = new OTLPTraceExporter({
    url: 'https://monitor.stela.pro/v1/traces',
    headers: {
        "x-api-key": "dc1de862-3fce-4251-ab9e-0ac3caf0ca25"
    }
});
const provider = new WebTracerProvider({
    resource: resourceFromAttributes({
        "service.name": "stela.frontend",
        "service.version": "1.0.0",
        "service.instance.id": window.location.hostname
    }),
    spanProcessors: [new HttpSpanNameProcessor(), new BatchSpanProcessor(exporter)]
});

provider.register({
    contextManager: new ZoneContextManager(),
});

registerInstrumentations({
  instrumentations: [
    new FetchInstrumentation({
      // Selects which backend servers are allowed to receive trace headers for linking traces across services.
      // Using /.*/ acts as a wildcard. For safer usage in production, replace with specific domains:
      // e.g. propagateTraceHeaderCorsUrls: [/api\.example\.com/, /my-backend\.internal/]
      propagateTraceHeaderCorsUrls: [/localhost\:49319/],
      ignoreUrls: [/monitor\.stela\.pro/],
    }),
    new UserInteractionInstrumentation({
      eventNames: ['click', 'input', 'submit'],
    }),
    new XMLHttpRequestInstrumentation({
      propagateTraceHeaderCorsUrls: [/localhost\:49319/],
      ignoreUrls: [/monitor\.stela\.pro/],
    }),
  ],
});